import { FunctionComponent } from 'react';

import { useSplitIO } from './useSplitIO';

type Props = {
  feature: string;
  children: React.ReactElement;
};

const Splitio: FunctionComponent<Props> = ({ feature, children }) => {
  const { status } = useSplitIO(feature);

  if (status) {
    return children;
  }

  return null;
};

export default Splitio;
